import { render, staticRenderFns } from "./text-question.vue?vue&type=template&id=37ff06d2"
import script from "./text-question.vue?vue&type=script&lang=js"
export * from "./text-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports